var _style, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrivalTimeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000131325458475425315510000004568058343437075361_);}\n\t.st1{fill:#AF1C2D;stroke:#AF1C2D;}\n\t.st2{fill:none;stroke:#AF1C2D;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073681556745164172200000009906311953126366126_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000073681556745164172200000009906311953126366126_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5,9.8v5c0,0.2,0.2,0.4,0.4,0.5l8.4,2.2l10.7,2.9c0.8,0.2,1.8,0.2,2.2-0.6c0.3-0.6,0.2-1.3-0.1-1.8 c-0.3-0.5-0.8-0.7-1.4-0.9l-5.6-1.6c-0.2,0-0.3-0.2-0.3-0.3L16.1,5c-0.1-0.2-0.2-0.3-0.3-0.3l-1.4-0.4c-0.3-0.1-0.6,0.2-0.6,0.5 v8.5c0,0.3-0.3,0.6-0.6,0.5l-5.1-1.3c-0.2,0-0.3-0.2-0.3-0.3L6.9,9.9C6.8,9.7,6.7,9.6,6.6,9.6L5.6,9.3C5.3,9.2,5,9.5,5,9.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.8,26.8h22.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivalTimeRed);
export default __webpack_public_path__ + "static/media/arrival-time-red.c5022475bcc44e997b2a5e99cfff5fe3.svg";
export { ForwardRef as ReactComponent };